export default __webpack_public_path__ + "static/enter-a96e6c096239bacd8fff9dad04c1ed2d.mp4";